import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action, set } from '@ember/object';

export default class TargetController extends Controller {
  @service automationSubaccountState;
  @service currentApplicationFlow;
  @service router;

  @readOnly('currentApplicationFlow.bankcBalanceId')
  bankcBalanceId;

  @action
  goBack() {
    this.router.transitionTo('signup.automation.withholding');
  }

  @action
  continue() {
    this.create();
  }

  @action
  skip() {
    set(this.automationSubaccountState, 'targetAmount', undefined);
    this.create();
  }

  @action
  async createWithholdingConfig() {
    await this.automationSubaccountState.createWithholdingForAccount(
      this.bankcBalanceId
    );
  }

  @action
  async create() {
    try {
      set(this, 'isLoading', true);
      await this.createWithholdingConfig();
      this.router.transitionTo('signup.automation.success');
    } catch {
      this.router.transitionTo('signup.automation.error');
    } finally {
      set(this, 'isLoading', false);
    }
  }
}
